export const UpNextCalendarEventsLoaderScenarioId = 'UpNextMailCalendarCacheId';
